import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchIssuesMessage: {
		id: 'issue-archival-archives.search.search-issues-message',
		defaultMessage: 'Search issues',
		description: 'Placeholder for search input box',
	},
});
